var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternalServerError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfdfdf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff000f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#f30410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e90512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e00612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#d90713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#d40713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d00814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#ce0814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#cc0814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff000f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fe010f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#fb0210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f60410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#f00511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#e90511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#e10612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#da0713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#d20814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#f6d0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#f5cca5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#f4c8a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#f3c49c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#f2c197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#f1bd92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#f1b98d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#f0b689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#efb384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#eeb081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#eead7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#eeab7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#edaa78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    y1: 0.003,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.447,
    y1: 0.289,
    x2: 0.5,
    y2: 0.849,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#f7d3ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#f6d2ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#f6d0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#f5cda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#f4c9a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#f3c49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#f2bd93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#efb587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "server-error",
    transform: "translate(-526 -405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ServerDown",
    transform: "translate(526 405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M108.847,26.253c21.3-4.689,45.739-2.092,68.835,8.115a134.893,134.893,0,0,1,59.844,52.726c15.1,24.637,23.536,56.014,15.175,81.956-8.441,25.958-33.628,46.514-59.666,55.71-26.07,9.244-52.992,7.127-78.978,6.812-25.906-.329-50.893,1.063-70.209-8.965C24.484,212.546,10.87,191.05,4.329,168.272c-6.493-22.746-5.866-46.742,3.131-65.826C16.44,83.282,33.838,69.061,51.63,56,69.406,42.867,87.544,30.941,108.847,26.253Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(141 48.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M96.526,38.094c15.1,24.637,23.536,56.014,15.175,81.956-8.441,25.958-33.627,46.514-59.666,55.71-12.364,4.384-24.92,6.213-37.476,6.89V21.481A4.481,4.481,0,0,1,19.04,17l61.554,0A135.415,135.415,0,0,1,96.526,38.094Z",
    fill: "#3f3f3f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M93.654,33.6H7.84a2.24,2.24,0,0,1-2.24-2.24V2.241A2.24,2.24,0,0,1,7.84,0H61.689A135.566,135.566,0,0,1,93.654,33.6Zm18.594,42H7.74a2.24,2.24,0,0,1-2.24-2.24V44.241A2.24,2.24,0,0,1,7.74,42H98.832A129.227,129.227,0,0,1,112.248,75.6Zm.189,42H7.74a2.24,2.24,0,0,1-2.24-2.24V86.241A2.24,2.24,0,0,1,7.74,84H113.895C115.664,95.491,115.4,106.961,112.437,117.6Zm-30.513,42H7.74a2.24,2.24,0,0,1-2.24-2.24v-29.12A2.24,2.24,0,0,1,7.74,126h101.7C103.731,139.076,93.809,150.558,81.924,159.6Z",
    fill: "#cfcfcf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M70.672,7.281H17.36a3.728,3.728,0,0,0-3.92,3.5,3.728,3.728,0,0,0,3.92,3.5H78.02q2.383,2.447,4.665,5.039H17.36a3.728,3.728,0,0,0-3.92,3.5,3.728,3.728,0,0,0,3.92,3.5H88.439q1.891,2.464,3.687,5.04H8.96a1.12,1.12,0,0,1-1.12-1.12V3.361a1.12,1.12,0,0,1,1.12-1.12H64.623Q67.7,4.657,70.672,7.281Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M102.684,49.28H17.26a3.523,3.523,0,1,0,0,7h88.618q1.055,2.5,2,5.04H17.26a3.522,3.522,0,1,0,0,7h93q.771,2.51,1.428,5.039H8.86a1.12,1.12,0,0,1-1.12-1.12V45.361a1.12,1.12,0,0,1,1.12-1.12h91.217Q101.43,46.726,102.684,49.28Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M113.018,115.362H8.86a1.12,1.12,0,0,1-1.12-1.12V87.361a1.12,1.12,0,0,1,1.12-1.12H114.214a80.578,80.578,0,0,1-1,28.273ZM49.46,103.321H17.26a3.523,3.523,0,1,0,0,7h32.2a3.523,3.523,0,1,0,0-7Zm60-12.04H17.26a3.523,3.523,0,1,0,0,7h92.2a3.522,3.522,0,1,0,0-7Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M84.767,157.361H8.86a1.12,1.12,0,0,1-1.12-1.12v-26.88a1.12,1.12,0,0,1,1.12-1.12h99.551C103.083,139.347,94.721,149.234,84.767,157.361ZM49.46,145.321H17.26a3.523,3.523,0,1,0,0,7h32.2a3.523,3.523,0,1,0,0-7Zm0-12.04H17.26a3.523,3.523,0,1,0,0,7h32.2a3.523,3.523,0,1,0,0-7Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M5.6,5.6V28H2.34A2.24,2.24,0,0,1,.1,25.761V7.841A2.24,2.24,0,0,1,2.34,5.6Zm-.1,42V70H2.24A2.24,2.24,0,0,1,0,67.761V49.841A2.24,2.24,0,0,1,2.24,47.6Zm0,42V112H2.24A2.24,2.24,0,0,1,0,109.761V91.841A2.24,2.24,0,0,1,2.24,89.6Zm0,42V154H2.24A2.24,2.24,0,0,1,0,151.761v-17.92a2.24,2.24,0,0,1,2.24-2.24Z",
    fill: "#4f4f4f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(162 94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M24.283,31.444l.8.285c4.054,1.49,14.664,6.177,12.4,21.83C36.806,81.17,52.827,80.67,53.17,96.1c.392,11.735-8.559,21.812-13.239,31.061-2.938,1.345-5.911,2.548-8.9,3.6a117.455,117.455,0,0,1-22.575,5.457A51.685,51.685,0,0,1,0,117.922c2.3,5.638,9.285,13.349,20.856,15.809-6.876-4.407-13.582-11.825-16.283-20.275l-.151-.488C-1.144,95.423,5,81.348,14.095,66.739l.294-.471C20.472,56.553,30.778,47.116,24.283,31.444Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M78.646,0l-.273.336c-5.549,6.98-5.206,16.317-2.348,24.85l.143.419.244.688C80,36.22,87.6,47.887,93.917,56.662A70.045,70.045,0,0,1,90.7,75.049c-8.441,25.958-33.628,46.514-59.666,55.71q-3.257,1.155-6.53,2.081c-8.564-12.55-13.2-27.429-12.391-41.315l.044-.671.054-.508c.9-7.981,4.468-17.4,10.658-23.865l.407-.418-.02.349c-.325,6.432,1.389,14.316,7.557,18.83l.341.243-.423-.721C17.095,60.905,36.55,30.542,54.75,15.75A147.252,147.252,0,0,1,77.937.358Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M66.48,78.144A25.551,25.551,0,0,0,70,88.23l.248.418a64.665,64.665,0,0,0,7.4,9.864,104.694,104.694,0,0,1-34.768,27.243c.691-9.174,4.192-17.823,8.964-26.329A164.94,164.94,0,0,1,66.48,78.144Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(2.44 65.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M108.473,100.974a55.72,55.72,0,0,1,5.6-.557c1.515-.1,3.052,2.277,3.726,3.586-2.009,1.446-1.955.81-4.4,1.9s-3.753,2.4-5.933,2.7c-1.777.322-3.6.909-5.36.539-.979-.25-11.357-3.876-11.159-6.088.133-1.481,10.542-1.847,11.138-1.927C103.575,100.93,106.616,101.254,108.473,100.974Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M61,119.441q8.278,5.919,11.6,46.084c-11.356-1-21.93-3.186-31.2-8a68.042,68.042,0,0,1-22.2-19.17C29.134,121.6,57.99,120.836,61,119.441Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M50.145,51.3q10.228,3.767,13.681,7.889c3.453,4.121,6.77,12.8,7.46,15.9q3.235,16.365,4.244,17.339c1.008.973,19.881,6.416,27.937,8.118a.714.714,0,0,1,.631.727q.033,6.781.023,7.185a.928.928,0,0,1-.239.733,1,1,0,0,1-.694.151c-12.343-.464-36.734-4.852-38.485-5.37q-1.751-.519-13.811-18.469Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M46.057,53.683l.153.006c2.5.063,4.736,1.094,7.091,1.757,1.9.54,4.386.3,6.142.946q3.851,1.423,7.926,19.771l.475,1.8c.864,3.369,1.279,6.158-.226,12.465-1.762,7.384-5.632,14.458-7.179,17.425A9.269,9.269,0,0,0,60,114.169c.946,4.221,6.814,12.589,6.98,14.736s-1.663,3.906-3.427,5.2a48.529,48.529,0,0,1-28.741,9.138,63.426,63.426,0,0,1-12.987-1.666q-1.842-2.156-3.553-4.463c.614-4.84,3.013-14.23,3.118-19.608.129-6.8-1.948-13.41-2.947-20.122a64.009,64.009,0,0,1,.11-19.525l.141-.842c.694-4.054,1.43-13.609,3.783-16.991l.487-.691c3.776-5.272,6.736-7.309,13.272-9.271,1.733-.6,7.776,3.445,9.825,3.623Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M114.207,100.348v3.361q-9.465,1.469-15.433,2.2a93.593,93.593,0,0,1-13.619.252l.069,3.979a4,4,0,0,1-3,3.943,20.751,20.751,0,0,1-4.567.762,20.8,20.8,0,0,1-4.591-.6,4,4,0,0,1-3.138-3.836l-.095-5.427a4,4,0,0,1,3.93-4.07l7.3-.127a4,4,0,0,1,3.693,2.3,125.125,125.125,0,0,0,13.986-.591Q104.627,101.771,114.207,100.348Z",
    fill: "#2f2f2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M113.271,99.8l15.067-8.629a2,2,0,0,1,2.73.742c.169.3,1.2,11.366,1.89,14.082a2,2,0,0,1-2.394,2.437l-16.595-3.87a2.586,2.586,0,0,1-.7-4.762Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M92.153,119.665l.814,46.7a209.482,209.482,0,0,1-28.034-1.735l-.776-44.479a13.1,13.1,0,0,1,12.869-13.327l1.8-.031A13.1,13.1,0,0,1,92.153,119.665Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M74.274,106.53c3.407-.253,5.036-.779,8.167.948s2.864,1.775,1.759,4.53-6.891,4.166-9.765,3.785a36.226,36.226,0,0,0-6.849-.324c-2.137.223-9.912,4.549-12.6,3.5-1.021-.4-6.672.09-8.29-.584-1.213-.506-5-2.081-3.8-5.885s.118-.947,10.369-1.245S72.048,106.7,74.274,106.53Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M17.3,84.4A148.392,148.392,0,0,1,20.652,64.41c1.64-4.962,4.042-8.579,8.526-11.265,1.589-.915,8.374,7.459,7.21,10.99s-5.548,31-3.549,42.674l24.948,3.872a27.386,27.386,0,0,1,.527,6.624,2.4,2.4,0,0,1-.406,1.48,2.529,2.529,0,0,1-1.795.664,204.48,204.48,0,0,1-27.271.639c-2.548-.109-5.228-.323-7.25-1.826-2.613-1.948-3.4-5.458-3.854-8.682C17.127,105.237,17.079,88.6,17.3,84.4Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M54.133-50.357q-8.38-8.049-11.383-7.6a4.429,4.429,0,0,0-4.086,4.433,3.989,3.989,0,0,0-.016.416l.074,5.7h0q-1.044-.031-1.76,0c-7.485.321-9.987,12.362-8.812,24.406.433,4.44,5.05,12.128,10.316,13.3,5.2,1.153,11-4.212,17.044,0-.48-9.281-1.063-10.211.7-9.09,8,3.68,5.833-17.792-2.075-16.626Z",
    transform: "translate(89.112) rotate(180)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M40.175-47.018q4.329.169,10.926,4.454Q47.789-49.045,40.074-49.9Z",
    transform: "translate(92.76 1.619) rotate(-178)",
    fill: "#eda977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M23.612,8.341c1.94,2.213,1.777,4.739.893,7.348C23.318,19.11,22.714,22.7,21.48,26.1c-1.376,3.7-3.753,7.235-7.4,8.672a16.134,16.134,0,0,1-3.5.86l1.747-2.666a8.96,8.96,0,0,1-2.006.921,8.6,8.6,0,0,1-6.575-.591A10.49,10.49,0,0,1,.035,29.713q3.721.258,4.54-.459A7.761,7.761,0,0,0,6.349,27.3c2-3.141,1.525-7.166,1.8-10.878A24.777,24.777,0,0,1,9.329,10.48,7.978,7.978,0,0,1,11.8,6.434,7.29,7.29,0,0,1,17,5.325,10.028,10.028,0,0,1,23.612,8.341Z",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M25.658,8.031c2.365-.024,4.374-.2,3.815,2.778a12.1,12.1,0,0,1-1,2.778.883.883,0,0,1-.94.68c-.68.065-1.369.065-2.049.065a5.2,5.2,0,0,1-2.187-.381,3.054,3.054,0,0,1-1.685-2.892A3.24,3.24,0,0,1,23.6,8.346,5.581,5.581,0,0,1,25.658,8.031Z",
    fill: "#e12e2e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M34.49,32.957a22.532,22.532,0,0,1,.57,4.224,11.256,11.256,0,0,1-.222,3.205,24.743,24.743,0,0,1-5.333-4.994,18.709,18.709,0,0,1-3.656-9.366c-.682-4.755-1.247-9.522.293-13.833A18.05,18.05,0,0,1,36.7,2.141a24.37,24.37,0,0,1,14.848-.429c1.988.539,3.384.793,7.191,3.548s4.586,4.333,6.188,6.133a13.1,13.1,0,0,1,2.589,4.971,12.86,12.86,0,0,1-.194,6.1c-.608,2.073-.867,4.479.46,6.219a2.85,2.85,0,0,0,2.162,1.19,1.755,1.755,0,0,0,1.773-1.491,3.751,3.751,0,0,1-1.845,4.3,6.135,6.135,0,0,1-4.965.237,5.351,5.351,0,0,1-1.832-.992,6.216,6.216,0,0,1-1.295-1.76c-1.353-2.425-2.032-5.119-3.042-7.736A10.329,10.329,0,0,0,53.9,16.929a12.922,12.922,0,0,0-6.325-1.083c-2.142-.07-7.764-.708-8.36-.85a10.292,10.292,0,0,0-3.786,4.917,11.1,11.1,0,0,0-.6,2.6l0-.014C27.542,20.775,28.7,32.339,34.49,32.957Z",
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 256,
    height: 256,
    transform: "translate(526 405)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalServerError);
export default __webpack_public_path__ + "static/media/InternalServerError.4ebf966a9b09ef6f98c98b7f75586f27.svg";
export { ForwardRef as ReactComponent };